<template>
    <div class="time-wrapper">
        <div class="tw-w-full tw-box-border tw-my-4">
            <h4 class="tw-mb-4 tw-text-lg tw-font-semibold tw-leading-6 tw-text-center">
                {{ translate('timepicker.title') }}
            </h4>
        </div>
        <select class="dropdown-menu tw-mt-0 tw-mb-6" v-model="selectedTime">
            <option disabled :value="null" class="dropdown-menu-item">
                {{ translate('timepicker.select_time') }}
            </option>
            <option v-for="time in availableTimes" :value="time" :key="time">
                {{ time }}
            </option>
        </select>
        <fieldset class="tw-my-6">
            <button class="btn btn-md btn-tertiary btn-fw" v-if="selectedTime" @click.prevent="confirmSelection">
                {{ translate('timepicker.confirm') }}
            </button>
        </fieldset>
        <div
            class="tw-text-xs tw-leading-tight tw-text-center tw-border tw-border-solid tw-border-blue tw-rounded-4 tw-p-2 tw-text-dark-grey support-message"
            v-html="translate('booking.info', { phone: phoneLink, email: emailLink })"
        ></div>
    </div>
</template>

<script>
import i18n from '@js/vue/mixins/i18n';
import { BOOKING_VIEWS } from '@js/vue/booking-views.js';
import { mapGetters, mapMutations } from 'vuex';
import { trackBookingTimeSelect } from '@js/vue/dataLayerUtils.js';
import { contactInfo } from '@js/vue/contact-info.js';

export default {
    name: 'TimePicker',
    mixins: [i18n],
    emits: ['timeSelected', 'changeView'],
    inject: ['translations'],
    created() {
        // Time already selected
        if (this.time) {
            this.selectedTime = this.time;
        }
    },
    methods: {
        ...mapMutations('booking', ['SET_TIME']),
        // set time in store, emit events for parent components
        confirmSelection() {
            trackBookingTimeSelect(this.serviceTitle);
            this.SET_TIME(this.selectedTime);
            this.$emit('timeSelected', this.selectedTime);
            this.$emit('changeView', BOOKING_VIEWS.OFFERS);
        },
    },
    data() {
        return {
            selectedTime: null,
            BOOKING_VIEWS,
            phoneLink: `<a class="tw-whitespace-nowrap tw-underline" href="tel:${contactInfo.phoneNumber}">${contactInfo.phoneNumber}</a>`,
            emailLink: `<a class="tw-whitespace-nowrap tw-underline" href="mailto:${contactInfo.emailAddress}">${contactInfo.emailAddress}</a>`,
        };
    },
    computed: {
        ...mapGetters('booking', ['getServiceTitle', 'getSelectedTime', 'getAvailableTimes']),
        time() {
            return this.getSelectedTime;
        },
        availableTimes() {
            return this.getAvailableTimes;
        },
        serviceTitle() {
            return this.getServiceTitle;
        },
    },
    watch: {
        availableTimes: {
            handler(newTimes) {
                if (this.selectedTime && !newTimes.includes(this.selectedTime)) {
                    this.selectedTime = null;
                }
            },
            immediate: true,
        },
    },
};
</script>
